const config={
    apiSecret:'7f2318bd1f9398064a51ca0922721.7d002dc7b6d78db8f8dbdb24220aa959bdb5304e33b99e21ffabca6dd578b349b728abda8a16b45db9955c46961150bda',
    baseUrl:'https://api.entity.hypersign.id'
}

export default config